import * as fitty from 'fitty';

export function bootstrap() {
  document.fonts.ready.then(() => {
    fitty.default('.js-fitty');
  });
}
